// extracted by mini-css-extract-plugin
module.exports = {"main":"about-module--main--upzB1","image":"about-module--image--1Sona","cards":"about-module--cards--3ta7_"};